module.exports = __webpack_public_path__ + "static/media/money-bill-alt.14a44584.svg";